import type { SVGAttributes } from 'react';

import { cn } from '@shared/lib/cn';

import { TREND_COLOR_CLASS, type TrendDirection } from './trend-icon.constant';
import { TREND_ICON_TEXT } from './trend-icon.text';

export interface TrendIconProps extends Omit<SVGAttributes<SVGSVGElement>, 'children'> {
  /** Figma `direction`. up = 위 삼각형(빨강), down = 아래 삼각형(파랑), flat = 가로 선. 기본 up */
  direction?: TrendDirection;
  /** 보조기기가 읽는 이름. 기본은 방향 이름(상승 · 하락 · 변동 없음). 옆 글자가 이미 말하면 `aria-hidden` 을 준다 */
  'aria-label'?: string;
}

/**
 * 증감 표시(20×20). 아이콘이 아니라 자료 표시라 모양을 직접 그린다 — Figma 의 벡터 그대로
 * (삼각형 14×10, 선 12 · 두께 2 를 20×20 가운데에).
 */
export function TrendIcon({ direction = 'up', className, ...rest }: TrendIconProps) {
  const hidden = rest['aria-hidden'] === true || rest['aria-hidden'] === 'true';
  return (
    <svg
      viewBox="0 0 20 20"
      role={hidden ? undefined : 'img'}
      aria-label={hidden ? undefined : TREND_ICON_TEXT[direction]}
      focusable="false"
      data-direction={direction}
      {...rest}
      className={cn('inline-block size-(--size-icon-md) shrink-0', className)}
    >
      {direction === 'up' ? (
        <path d="M10 5 L17 15 L3 15 Z" className={TREND_COLOR_CLASS.up} />
      ) : null}
      {direction === 'down' ? (
        <path d="M10 15 L3 5 L17 5 Z" className={TREND_COLOR_CLASS.down} />
      ) : null}
      {direction === 'flat' ? (
        <path d="M4 10 L16 10" fill="none" strokeWidth={2} className={TREND_COLOR_CLASS.flat} />
      ) : null}
    </svg>
  );
}
